import React from "react";

const UploadStatusDot = ({ done, loading, step }) => (
  <span
    style={{
      width: 22,
      height: 22,
      borderRadius: "50%",
      backgroundColor: done ? "#4caf50" : loading ? "#ff9800" : "#e0e0e0",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      color: "white",
      fontSize: 12,
      flexShrink: 0,
      transition: "background-color 0.3s",
    }}
  >
    {done ? "✓" : loading ? "…" : step}
  </span>
);

const UploadStatusRow = ({ done, loading, step, label }) => (
  <div style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
    <UploadStatusDot done={done} loading={loading} step={step} />
    <span
      style={{
        color: done ? "#4caf50" : loading ? "#ff9800" : "#666",
        fontSize: "0.875rem",
        transition: "color 0.3s",
      }}
    >
      {label}
    </span>
  </div>
);

const ActionFilesProgress = ({ actionUploadStates }) => {
  const hasAny = actionUploadStates.some((s) => s.hasFile);
  if (!hasAny) return null;

  return (
    <>
      <div
        style={{
          paddingLeft: "0.25rem",
          fontSize: "0.78rem",
          color: "#94a3b8",
          fontWeight: 600,
          letterSpacing: "0.04em",
          textTransform: "uppercase",
        }}
      >
        Archivos de botones
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.4rem" }}>
        {actionUploadStates.map((state, i) => {
          if (!state.hasFile) return null;
          return (
            <UploadStatusRow
              key={i}
              done={state.done}
              loading={state.loading}
              step={`B${i + 1}`}
              label={
                state.done
                  ? `Botón ${i + 1}: archivo subido`
                  : state.loading
                    ? `Botón ${i + 1}: subiendo archivo...`
                    : `Botón ${i + 1}: subir archivo adjunto`
              }
            />
          );
        })}
      </div>
    </>
  );
};

export const CampaignUploadProgress = ({
  templateFile,
  isUploadedFile,
  isLoadingUploadFile,
  isLoadingActionFiles,
  actionUploadStates,
  isTemplateCreated,
  isLoadingTemplate,
  isSentBroadcast,
  isLoadingBroadcast,
  fileStatusText,
  templateStatusText,
  broadcastStatusText,
}) => {
  let step = 0;
  const nextStep = () => {
    step += 1;
    return step;
  };

  return (
    <div
      style={{
        marginTop: "1rem",
        padding: "1rem 1.25rem",
        backgroundColor: "#f8fafc",
        borderRadius: "10px",
        border: "1px solid #e2e8f0",
      }}
    >
      <h4 style={{ margin: "0 0 0.75rem 0", color: "#1e293b", fontSize: "0.9rem" }}>
        Estado de la Campaña:
      </h4>

      <div style={{ display: "flex", flexDirection: "column", gap: "0.6rem" }}>
        {templateFile && (
          <UploadStatusRow
            done={isUploadedFile && !isLoadingUploadFile}
            loading={isLoadingUploadFile && !isLoadingActionFiles}
            step={nextStep()}
            label={fileStatusText()}
          />
        )}

        <ActionFilesProgress actionUploadStates={actionUploadStates} />

        <UploadStatusRow
          done={isTemplateCreated}
          loading={isLoadingTemplate}
          step={nextStep()}
          label={templateStatusText()}
        />

        <UploadStatusRow
          done={isSentBroadcast}
          loading={isLoadingBroadcast}
          step={nextStep()}
          label={broadcastStatusText()}
        />
      </div>
    </div>
  );
};
